import { NetworkView } from '../person/network';
import { useOrganisationRecord } from './record';

/**
 * **The organisation's Network tab** (owner ruling, 2026-09-09: "the network
 * graph should be on a separate tab … Network (the network graph, just like with
 * people)").
 *
 * Literally the person tab's own drawing, over this record's id: `GET
 * /subjects/:id/network` has taken an organisation since chunk 2a, and the graph
 * has never cared what kind of subject sits at the centre. One component, one
 * reading, so the two pages cannot drift into two pictures of the same graph.
 *
 * It has no heading of its own. On the record page the graph was a block among
 * blocks and needed one; a tab is already named by the tab it is under.
 */
export function OrganisationNetworkTab() {
  const { entityId } = useOrganisationRecord();
  return <NetworkView subjectId={entityId} />;
}
